var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8085 10.5128C10.9143 10.4035 11.0857 10.4035 11.1914 10.5128L14.6862 14.1264C14.7919 14.2357 14.9633 14.2357 15.069 14.1264L15.9623 13.2027C16.0681 13.0934 16.0681 12.9162 15.9623 12.8068L11.1914 7.87369C11.0857 7.76438 10.9143 7.76438 10.8085 7.87369L6.03758 12.8068C5.93186 12.9162 5.93186 13.0934 6.03758 13.2027L6.9309 14.1264C7.03662 14.2357 7.20802 14.2357 7.31374 14.1264L10.8085 10.5128Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.4da694d94d674a5a2d56998f20c0f2f8.svg";
export { ForwardRef as ReactComponent };